import { isDisplayableGenre, isOwnImage } from "./utils";

export interface ArtistSeoEnrichment {
  image_url?: string | null;
  spotify_id?: string | null;
  genres?: readonly string[] | null;
  hidden?: boolean;
  canonical_id?: number | null;
}

/** Only promote profiles with the three enrichments visitors can use. */
export function hasArtistSeoEnrichment(artist: ArtistSeoEnrichment): boolean {
  return artist.hidden !== true && artist.canonical_id == null
    && !!artist.image_url && isOwnImage(artist.image_url)
    && !!artist.spotify_id?.trim()
    && (artist.genres ?? []).some((genre) => {
      const tag = genre.trim();
      return !!tag && !/^(unknown|n\/a|none)$/i.test(tag) && isDisplayableGenre(tag);
    });
}

/** A complete performer supplies imagery, previews and genres for the show.
 *  Other support acts on the same bill need not be fully enriched. */
export function hasEventSeoEnrichment(event: { attractions: readonly ArtistSeoEnrichment[] }): boolean {
  return event.attractions.some(hasArtistSeoEnrichment);
}

export function artistLinkRel(artist: ArtistSeoEnrichment, hasUpcomingShows = true): "nofollow" | undefined {
  return hasUpcomingShows && hasArtistSeoEnrichment(artist) ? undefined : "nofollow";
}

export function eventLinkRel(event: { attractions: readonly ArtistSeoEnrichment[] }): "nofollow" | undefined {
  return hasEventSeoEnrichment(event) ? undefined : "nofollow";
}

/** PostgREST can return a related row as either an object or an array. */
export function joinedArtists(rows: readonly {
  attractions: ArtistSeoEnrichment | ArtistSeoEnrichment[] | null;
}[]): ArtistSeoEnrichment[] {
  return rows.flatMap((row) => Array.isArray(row.attractions) ? row.attractions : row.attractions ? [row.attractions] : []);
}
